import SingleConversion from "../Panelview/Info/SingleConversion";
import InfoEntry, {
  InfoEntryPoweredge,
  InfoEntryProcesses,
  InfoLinkLabel,
} from "../Panelview/Info/InfoEntry";
import LocationInfo from "../Panelview/Info/LocationInfo";
import NodeLocationInfo from "../Panelview/Info/NodeLocationInfo";

export function buildNodeInfo(
  selected,
  allowed_conversion,
  pathwayInternalId,
  onChangeLabel,
  protein_type,
  header_label
) {
  let info = [];

  info.push({
    key: "Element",
    render: <InfoEntry label="Element" value="node" />,
  });

  info.push({
    key: "Label",
    render: (
      <InfoLinkLabel
        label={"Label"}
        value={selected.label}
        node_type={selected.node_type}
      />
    ),
  });
  info.push({
    key: "Type",
    render: <InfoEntry label="Type" value={selected.node_type} />,
  });

  if ("User Numeric Value" in selected) {
    info.push({
      key: "User Numeric Value",
      render: (
        <InfoEntry
          label="User Numeric Value"
          value={`${selected["User Numeric Value"]} (${header_label})`}
        />
      ),
    });
  }

  if (
    selected.node_type !== "compartment" &&
    selected.node_type !== "powernode"
  ) {
    info.push({
      key: "Location",
      render:
        selected.location !== "" ? (
          <NodeLocationInfo
            location={selected.location}
            color={selected.color}
            userColorFlag={"User Numeric Value" in selected ? true : false}
          />
        ) : (
          ""
        ),
    });

    info.push({
      key: "Conversion",
      render: (
        <SingleConversion
          label={"Conversion"}
          allowed_conversion={allowed_conversion}
          pathwayInternalId={pathwayInternalId}
          native={selected.native}
          nodeId={selected.id}
          onChangeLabel={onChangeLabel}
          protein_type={protein_type}
        />
      ),
    });
  }

  if (selected.node_type === "compartment") {
    fillLocationInfo(selected.color, selected.location, info);
  }

  return info;
}

const isPowerNode = (nodeData) => {
  return nodeData.node_type === "powernode";
};

export function buildEdgeInfo(selected, sourceData, targetData, network_type) {
  let info = [];

  const flagPowerEdge = network_type === "powergraph";

  info.push({
    key: "Element",
    render: (
      <InfoEntry
        label="Element"
        value={
          isPowerNode(sourceData) || isPowerNode(targetData)
            ? "<Power Edge>"
            : "edge"
        }
      />
    ),
  });
  info.push({
    key: "Source",
    render: (
      <InfoEntry
        label="Source"
        value={isPowerNode(sourceData) ? "<Power Node>" : sourceData.label}
      />
    ),
  });
  info.push({
    key: "Source Location",
    render: (
      <InfoEntry
        label="Source Location"
        value={isPowerNode(sourceData) ? "" : sourceData.location}
      />
    ),
  });
  info.push({
    key: "Target",
    render: (
      <InfoEntry
        label="Target"
        value={isPowerNode(targetData) ? "<Power Node>" : targetData.label}
      />
    ),
  });
  info.push({
    key: "Target Location",
    render: (
      <InfoEntry
        label="Target Location"
        value={isPowerNode(targetData) ? "" : targetData.location}
      />
    ),
  });

  info.push({
    key: "General direction",
    render: <InfoEntry label="General direction" value={selected.direction} />,
  });

  if (selected.type !== null && "type" in selected) {
    info.push({
      key: "Process Direction",
      render: flagPowerEdge ? (
        <InfoEntryPoweredge label={"Process direction"} value={selected.type} />
      ) : (
        <InfoEntryProcesses
          label="Process direction"
          value={getProcessDirection(
            selected,
            sourceData.label,
            targetData.label
          )}
        />
      ),
    });
  }

  return info;
}

function getProcessDirection(selected, sourceLabel, targetLabel) {
  let processDirection = [];

  for (let i = 0; i < selected.type.length; i++) {
    if (selected.type[i][1].length > 1) {
      processDirection.push({
        process: selected.type[i][0],
        span: selected.type[i][1].length,
        direction: selected.type[i][1][0],
        // arrow: "caso",
      });
      for (let j = 1; j < selected.type[i][1].length; j++) {
        processDirection.push({
          process: false,
          span: false,
          direction: selected.type[i][1][j],
          // arrow: "caso",
        });
      }
    } else {
      processDirection.push({
        process: selected.type[i][0],
        span: selected.type[i][1].length,
        direction: selected.type[i][1][0],
        // arrow: "caso",
      });
    }
  }

  let spaces = "\u2002\u2002\u2002\u2002";
  for (let i = 0; i < sourceLabel.length; i++) {
    spaces += "\u2002";
  }

  return {
    source: sourceLabel,
    space: spaces,
    target: targetLabel,
    processDirection: processDirection,
  };
}

const fillLocationInfo = (color, location, info) => {
  info.push({
    key: "Location",
    render: <InfoEntry label="Location" value={location} color={color} />,
  });
  info.push({
    key: "Accession",
    render: (
      <LocationInfo
        location={location}
        label={"Accession"}
        value={"accession"}
        keyLocLinks={"accession"}
      />
    ),
  });

  info.push({
    key: "GO",
    render: (
      <LocationInfo
        location={location}
        label={"GO"}
        value={"gene_ontology"}
        keyLocLinks={"go"}
      />
    ),
  });

  info.push({
    key: "isa",
    render: <LocationInfo location={location} label={"Is a"} value={"is_a"} />,
  });

  info.push({
    key: "interesting_references",
    render: (
      <LocationInfo
        location={location}
        label={"Interesting references"}
        value={"interesting_references"}
      />
    ),
  });

  info.push({
    key: "description",
    render: (
      <LocationInfo
        location={location}
        label={"Description"}
        value={"description"}
      />
    ),
  });
};
